import React from 'react'
import { Container, ContainerInterno, BoxCol4, BoxCol6, TagContador, TextoBanner, ImgNaoSejaDemitido, TituloNaoSejaDemitido, LegendaNaoSejaDemitido } from './Styled'
import bgBannerDesktop from 'images/renovacao-antecipada-2026/bg-nao-seja-mais-demitido.jpg'
import bgBannerMobile from 'images/renovacao-antecipada-2026/bg-nao-seja-mais-demitido-mobile.jpg'
import naoSejaMaisDemitido from 'images/renovacao-antecipada-2026/nao-seja-mais-demitido.png'
// import { replace } from 'lodash'
import TarjaCountdown from '../TarjaCountdown/TarjaCountdown'

export default function BannerPrincipal ({ nome, desconto, dataFim }) {

	return (
		<Container bgDesktop={bgBannerDesktop} bgMobile={bgBannerMobile} id='bannerPromocao'>
			<ContainerInterno>

				{/* Textos Banner */}
				<BoxCol4 className='boxTextos'>

					{/* Tag Contador */}
					<TagContador><span>ESTA OFERTA EXCLUSIVA PARA<br /> ASSINANTES EXPIRA EM:</span></TagContador>

					{/* Tarja */}
					<TarjaCountdown
						date={new Date()}
						to={dataFim}
						onFinish={() => window.location.reload()}
					/>

					{/* Texto Banner */}
					<TextoBanner><strong>PARABÉNS</strong>, {nome.split(" ")[0]}!<br />VOCÊ <strong>GANHOU<br /> {desconto}% DE DESCONTO</strong><br /> PARA RENOVAR SUA<br /> ASSINATURA HOJE</TextoBanner>

				</BoxCol4>

				{/* Textos Direita */}
				<BoxCol6>
					
					{/* Imagem */}
					<ImgNaoSejaDemitido src={naoSejaMaisDemitido} />

					{/* Título */}
					<TituloNaoSejaDemitido>Estude com o material utilizado por <strong>7 a cada 10<br /> aprovados</strong> em concursos no país!</TituloNaoSejaDemitido>

					{/* Legenda */}
					<LegendaNaoSejaDemitido>353 editais e 73.534 vagas previstas para 2026</LegendaNaoSejaDemitido>

				</BoxCol6>

			</ContainerInterno>
		</Container>
	)
}
